import { BybButton } from "@Components/common/byb-ds";
import { GameModeCard, GameModeOptionButton } from "@Components/game/game-mode";
import { useMatchPlayContext } from "@Context/game/match-play/match-play-context";
import { useSelectionDisplayText } from "@hooks/game/selection/use-selection-display-text";
import useI18n from "@i18n";
import { ChevronRight } from "@mui/icons-material";
import { Button, CircularProgress, Stack, Typography, useTheme } from "@mui/material";

const MatchPlayOverview = () => {
  const { i18n } = useI18n();
  const { getPositionSelectionDisplayText } = useSelectionDisplayText();
  const theme = useTheme();
  const { isWaitingForGameplay, openPositionSelect, selectedPositions, startQuickPlay } = useMatchPlayContext();

  return (
    <GameModeCard flex={0.6} sx={{ padding: theme.spacing(8), gap: 10 }}>
      <Stack spacing={3} flex={0.5} justifyContent="center" padding={theme.spacing(0, 8)}>
        <Typography variant="text1xl500" color="text.secondary">
          {i18n("match-play.subtitle")}
        </Typography>
        <Typography variant="text6xl800" color="text.primary">
          {i18n("match-play.title")}
        </Typography>
        <Typography variant="text1xl500" color="text.secondary">
          {i18n("match-play.description")}
        </Typography>
      </Stack>

      <Stack direction="row" spacing={2} flex={0.25}>
        <GameModeOptionButton onClick={openPositionSelect} sx={{ flex: 1 }}>
          <Typography variant="text1xl600" color="dsBase.v200">
            {getPositionSelectionDisplayText(selectedPositions)}
          </Typography>
          <ChevronRight sx={{ color: theme.palette.dsNeutral.v200 }} fontSize="large" />
        </GameModeOptionButton>

        {isWaitingForGameplay ? (
          <Stack flex={1} justifyContent="center" alignItems="center">
            <CircularProgress />
          </Stack>
        ) : (
          <Button size="large" onClick={startQuickPlay} sx={{ flex: 1 }}>
            {i18n("play")}
          </Button>
        )}
      </Stack>
    </GameModeCard>
  );
};

export default MatchPlayOverview;
